import { useState } from 'react';
import { Button } from '../ui/button';
import { Field, Pick, MonthPick } from './formBits';
import { eur } from './api';

const LABEL = { loyer: 'Loyer', assurance: 'Assurance', energie: 'Électricité / énergie', telephone: 'Téléphone', internet: 'Internet', comptabilite: 'Comptabilité', logiciel: 'Logiciel',
    carburant: 'Carburant', entretien: 'Entretien locaux', publicite: 'Publicité', fournitures: 'Fournitures', restaurant: 'Restaurant', deplacement: 'Déplacement', formation: 'Formation', sav: 'SAV', autre: 'Autre' };

export function AgencyForm({ d, opts, busy, submit }) {
    const [cat, setCat] = useState(d.categorie && LABEL[d.categorie] ? d.categorie : '');
    const [mois, setMois] = useState((d.date_facture || '').slice(0, 7) || opts.mois_courant);
    return (
        <div className="space-y-3" data-testid="assign-agency-form">
            <div className="grid grid-cols-2 gap-2">
                <Field label="Catégorie"><Pick value={cat} onChange={setCat} items={opts.categories.map(c => [c, LABEL[c] || c])} placeholder="Choisir" testId="assign-agency-category" /></Field>
                <Field label="Mois comptable"><MonthPick value={mois} onChange={setMois} testId="assign-agency-month" /></Field>
            </div>
            <p className="text-[12px] text-gray-500">Enregistrée dans les frais d'agence ({eur(d.montant_ttc)} TTC). Aucune marge de véhicule n'est modifiée.</p>
            <Button disabled={busy || !cat || !mois} onClick={() => submit({ type: 'frais_agence', categorie: cat, mois_comptable: mois },
                `Enregistrer ${eur(d.montant_ttc)} TTC en frais d'agence « ${LABEL[cat]} » sur ${mois} ?\nAucune marge de véhicule modifiée.`)} data-testid="assign-agency-submit">Enregistrer en frais d'agence</Button>
        </div>
    );
}

export function MutualForm({ d, opts, busy, submit, onSplit }) {
    const [mois, setMois] = useState((d.date_facture || '').slice(0, 7));
    return (
        <div className="space-y-4" data-testid="assign-mutual-form">
            <div className="rounded-lg border border-gray-100 p-3 space-y-2">
                <p className="text-[13px] font-medium text-gray-900">Mutualisé du mois</p>
                <p className="text-[12px] text-gray-500">Réparti automatiquement sur les véhicules vendus du mois choisi. Les mois gelés sont bloqués jusqu'à votre autorisation.</p>
                <div className="flex gap-2 items-end">
                    <Field label="Mois d'affectation" className="flex-1"><MonthPick value={mois} onChange={setMois} disabledMonths={opts.mois_geles} testId="assign-mutual-month" /></Field>
                    <Button disabled={busy || !mois || opts.mois_geles.includes(mois)} onClick={() => submit({ type: 'frais_mutualise', mois_affectation: mois },
                        `Ajouter ${eur(d.montant_ttc)} TTC aux frais mutualisés de ${mois} ?\nLes marges des véhicules vendus ce mois-là baisseront ; recalcul automatique des commissions.`)} data-testid="assign-mutual-submit">Valider</Button>
                </div>
            </div>
            <div className="rounded-lg border border-gray-100 p-3 space-y-2">
                <p className="text-[13px] font-medium text-gray-900">Répartir sur des véhicules choisis</p>
                <p className="text-[12px] text-gray-500">En euros ou en pourcentage ; le total ne peut pas dépasser la facture. Chaque ligne est ensuite validée sur son véhicule.</p>
                <Button variant="outline" disabled={busy} onClick={onSplit} data-testid="assign-mutual-split">Répartir…</Button>
            </div>
        </div>
    );
}
